import { hasPdfSignature, looksLikeGuideCsv } from "../shared/import-file";

export type ImportKind = "csv" | "pdf";

export async function detectImportKind(file: File): Promise<ImportKind> {
  const sample = await file.slice(0, 64 * 1024).arrayBuffer();
  if (hasPdfSignature(new Uint8Array(sample))) return "pdf";
  const sampleText = new TextDecoder().decode(sample);
  if (
    looksLikeGuideCsv(sampleText) ||
    file.name.toLocaleLowerCase("en-US").endsWith(".csv") ||
    file.type === "text/csv"
  )
    return "csv";
  throw new Error("Choose a CSV or PDF file.");
}
